import { render } from "./App.vue?vue&type=template&id=479092a8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=479092a8&lang=css"

import exportComponent from "E:\\wb\\sxyd-pub-cli5（公众版网页前端）\\sxyd-pub-cli5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__